import { useTranslation } from 'react-i18next'

/**
 * Recaptcha v3 attribution paragraph required by Google's ToS whenever the
 * (invisible) badge is hidden. Renders the localized notice with links to
 * Google's privacy policy and terms of service.
 */
export function RecaptchaNotice() {
  const { t } = useTranslation()
  return (
    <p className="text-center text-xs text-muted-foreground/60 leading-relaxed">
      {t('auth.recaptcha_notice_prefix')}{' '}
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-muted-foreground"
      >
        {t('auth.recaptcha_privacy')}
      </a>{' '}
      {t('auth.recaptcha_and')}{' '}
      <a
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-muted-foreground"
      >
        {t('auth.recaptcha_terms')}
      </a>{' '}
      {t('auth.recaptcha_notice_suffix')}
    </p>
  )
}
